"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
exports.HelpButton = (props) => React.createElement("a", { href: "#", title: props.message, onClick: (event) => {
        event.preventDefault();
        alert(props.message);
    } },
    React.createElement("img", { src: "/sb/static/images/help.png", style: { verticalAlign: "middle" }, alt: "Help" }));
//# sourceMappingURL=help button.js.map


// WEBPACK FOOTER //
// ./build/lib/help button.js